<template>
    <div>
        <div class="leaves_top"></div>

        <HeaderMenu_Admin />
        <LateralMenu_Admin />

        <div id="admin-room-sessions">
            <div class="content">
                <div class="admin-tools header">
                    <router-link to="/resultats/nestor" v-slot="{ href }">
                        <a v-bind:href="href" target="_blank">Liste des scores</a>
                    </router-link>
                    <router-link to="/admin/logout" v-slot="{ href }">
                        <a v-bind:href="href">Déconnexion</a>
                    </router-link>
                </div>
            </div>

            <div class="content">
                <span class="title">
                    Enregistrer une nouvelle session
                </span>
                <div class="new-session-container">
                    <div class="new-session-display">
                        <div class="form-infos">
                            <div class="input-group">
                                <div class="input-left col-4">
                                    <span>Nom de l'équipe</span>
                                    <input type="text" v-model="formNestorSession_teamName" />
                                </div><!--
                                --><div class="input-left col-4">
                                    <span>Bonus</span>
                                    <select v-model="formNestorSession_bonus">
                                        <option value="1">★</option>
                                        <option value="2">★ ★</option>
                                        <option value="3">★ ★ ★</option>
                                        <option value="4">★ ★ ★ ★</option>
                                        <option value="5">★ ★ ★ ★ ★</option>
                                        <option value="BOOM">BOOM !</option>
                                    </select>
                                </div><!--
                                --><div class="input-left col-4">
                                    <span>Score</span>
                                    <input type="text" v-model="formNestorSession_score" />
                                </div><!--
                                --><div class="input-left col-4">
                                    <button v-on:click="performNestorSession()"
                                        v-bind:style="{ cursor: nestor_session_isSubmit || (!formNestorSession_teamName || !formNestorSession_bonus || !formNestorSession_score) ? 'not-allowed' : '' }">Enregistrer</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="list-container content">
                <span class="title"><span class="material-icons">&#xE05E</span>&nbsp;Dernières sessions enregistrées</span>
                <div>
                    <span>Date</span>
                    <span>Équipe</span>
                    <span>Bonus</span>
                    <span>Score</span>
                    <span>&nbsp;</span>
                </div>
                <div v-for="nestor_session in nestor_sessions">
                    <span>{{ nestor_session.session_time.day }}/{{nestor_session.session_time.month }}</span>
                    <span>{{ nestor_session.team_name }}</span>
                    <template v-if="nestor_session.boom_was_triggered">
                        <span class="boom"></span>
                    </template>
                    <template v-else>
                        <span>
                            <span class="star" v-for="num in nestor_session.bonus"> ★ </span>
                        </span>
                    </template>
                    <span>{{ nestor_session.score }}</span>
                    <div class="tools">
                        <span class="delete" v-on:click="nestorSessionItem_onDeleteClicked(nestor_session)">&#x274C;</span>
                    </div>
                </div>
            </div>
        </div>

        <div id="leaves_sides">
            <div class="left"></div>
            <div class="right"></div>
        </div>

        <Footer />
    </div>
</template>

<script>
import HeaderMenu_Admin from '../../components/HeaderMenu_Admin.vue';
import LateralMenu_Admin from '../../components/LateralMenu_Admin.vue';
import Footer from '../../components/Footer.vue';

import axios from 'axios';

export default {
    name: "Admin_NestorSessionsPage",
    components: {
        HeaderMenu_Admin,
        LateralMenu_Admin,
        Footer
    },
    data: () => ({
        // data
        nestor_sessions: [],
        // form
        formNestorSession_teamName: null,
        formNestorSession_bonus: null,
        formNestorSession_score: null,
        // usage
        nestor_session_isSubmit: false,
        nestor_sessions_isDisplayed: false
    }),
    methods: {
        redirect: function(url) {
            window.open(url, '_blank');
        },
        formNestorSessionInfos_bindClass: function(form_dataField) {
            return { 'has-error': this.formRoomSessionInfos_errorFields.includes(form_dataField) };
        },
        nestorSessionItem_onDeleteClicked: function(nestor_session) {
            var ok = confirm('Voulez-vous vraiment supprimer la session de ' + nestor_session.team_name + ' du ' + nestor_session.session_time.day + '/' + nestor_session.session_time.month + ' (' + nestor_session.score + ') ?');
            if (ok) {
                var token = localStorage.getItem('admin-token');
                axios.delete('https://api.lockquest.fr/nestor_session/' + nestor_session.identifier, {
                    headers: {
                        'Authorization': `Basic ` + token
                    }
                }).then((response) => {
                    this.loadSessions();
                }).catch((error) => {
                    alert('Une erreur est survenue, merci de contacter notre équipe.');
                });
            }
        },
        performNestorSession: function() {
            this.nestor_session_isSubmit = true;

            var self = this;
            var token = localStorage.getItem('admin-token');
            axios.post('https://api.lockquest.fr/nestor_session', {
                team_name: this.formNestorSession_teamName,
                bonus: this.formNestorSession_bonus == 'BOOM' ? 0 : this.formNestorSession_bonus,
                boom_was_triggered: this.formNestorSession_bonus == 'BOOM',
                score: this.formNestorSession_score
            }, {
                headers: {
                    'Authorization': `Basic ` + token,
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then((response) => {
                self.loadSessions();

                self.formNestorSession_teamName = null;
                self.formNestorSession_bonus = null;
                self.formNestorSession_score = null;
            }).then(() => {
                self.nestor_session_isSubmit = false;
            });
        },
        loadSessions: function() {
            axios.get('https://api.lockquest.fr/nestor_sessions?nb_items=30')
                .then((response) => {
                    this.nestor_sessions = response.data;
                });
        }
    },
    mounted() {
        this.loadSessions();
    }
}
</script>